let g = [];

// los angeles county
g["agoura hills"] = { lt: 34.154326, lg: -118.763998, n: "Agoura Hills, CA, USA" }; 
g["alhambra"] = { lt: 34.083282, lg: -118.134374, n: "Alhambra, CA, USA" }; 
g["arcadia"] = { lt: 34.136351, lg: -118.041234, n: "Arcadia, CA, USA" }; 
g["artesia"] = { lt: 33.868998, lg: -118.080702, n: "Artesia, CA, USA" }; 
g["avalon"] = { lt: 33.341539, lg: -118.32818, n: "Avalon, CA, USA" }; 
g["azusa"] = { lt: 34.140307, lg: -117.911439, n: "Azusa, CA, USA" }; 
g["baldwin park"] = { lt: 34.084386, lg: -117.968937, n: "Baldwin Park, CA, USA" }; 
g["bell"] = { lt: 33.97995, lg: -118.17539, n: "Bell, CA, USA" }; 
g["bell gardens"] = { lt: 33.966753, lg: -118.154278, n: "Bell Gardens, CA, USA" }; 
g["bellflower"] = { lt: 33.889366, lg: -118.125178, n: "Bellflower, CA, USA" }; 
g["beverly hills"] = { lt: 34.074197, lg: -118.400177, n: "Beverly Hills, CA, USA" }; 
g["bradbury"] = { lt: 34.153458, lg: -117.968231, n: "Bradbury, CA, USA" }; 
g["burbank"] = { lt: 34.184988, lg: -118.32195, n: "Burbank, CA, USA" }; 
g["calabasas"] = { lt: 34.139903, lg: -118.654626, n: "Calabasas, CA, USA" }; 
g["carson"] = { lt: 33.83538, lg: -118.244443, n: "Carson, CA, USA" }; 
g["cerritos"] = { lt: 33.865965, lg: -118.066749, n: "Cerritos, CA, USA" }; 
g["claremont"] = { lt: 34.120086, lg: -117.714956, n: "Claremont, CA, USA" }; 
g["commerce"] = { lt: 33.996489, lg: -118.148996, n: "Commerce, CA, USA" }; 
g["compton"] = { lt: 33.893817, lg: -118.225244, n: "Compton, CA, USA" }; 
g["covina"] = { lt: 34.092115, lg: -117.881176, n: "Covina, CA, USA" }; 
g["cudahy"] = { lt: 33.962605, lg: -118.181104, n: "Cudahy, CA, USA" }; 
g["culver city"] = { lt: 34.024713, lg: -118.399070, n: "Culver City, CA, USA" };
g["diamond bar"] = { lt: 33.99722, lg: -117.813063, n: "Diamond Bar, CA, USA" }; 
g["downey"] = { lt: 33.93753, lg: -118.127677, n: "Downey, CA, USA" }; 
g["duarte"] = { lt: 34.139951, lg: -117.957452, n: "Duarte, CA, USA" }; 
g["el monte"] = { lt: 34.07595, lg: -118.031148, n: "El Monte, CA, USA" }; 
g["el segundo"] = { lt: 33.916582, lg: -118.400684, n: "El Segundo, CA, USA" }; 
g["gardena"] = { lt: 33.894711, lg: -118.306739, n: "Gardena, CA, USA" }; 
g["glendale"] = { lt: 34.179912, lg: -118.240809, n: "Glendale, CA, USA" }; 
g["glendora"] = { lt: 34.141752, lg: -117.83715, n: "Glendora, CA, USA" }; 
g["hawaiian gardens"] = { lt: 33.831488, lg: -118.072002, n: "Hawaiian Gardens, CA, USA" }; 
g["hawthorne"] = { lt: 33.91216, lg: -118.347954, n: "Hawthorne, CA, USA" }; 
g["hermosa beach"] = { lt: 33.866833, lg: -118.395913, n: "Hermosa Beach, CA, USA" }; 
g["hidden hills"] = { lt: 34.163621, lg: -118.657276, n: "Hidden Hills, CA, USA" }; 
g["huntington park"] = { lt: 33.979678, lg: -118.213071, n: "Huntington Park, CA, USA" }; 
g["industry"] = { lt: 33.995221, lg: -117.919566, n: "Industry, CA, USA" }; 
g["inglewood"] = { lt: 33.956424, lg: -118.34385, n: "Inglewood, CA, USA" }; 
g["irwindale"] = { lt: 34.119056, lg: -117.962635, n: "Irwindale, CA, USA" }; 
g["la canada flintridge"] = { lt: 34.209262, lg: -118.204247, n: "La Cañada Flintridge, CA, USA" }; 
g["la habra heights"] = { lt: 33.960304, lg: -117.952877, n: "La Habra Heights, CA, USA" }; 
g["hollywood"] = { lt: 34.094531, lg: -118.322273, n: "Hollywood, CA, USA" }; 
g["la mirada"] = { lt: 33.902543, lg: -118.005474, n: "La Mirada, CA, USA" }; 
g["la puente"] = { lt: 34.030654, lg: -117.950564, n: "La Puente, CA, USA" }; 
g["la verne"] = { lt: 34.118342, lg: -117.770582, n: "La Verne, CA, USA" }; 
g["lakewood"] = { lt: 33.846969, lg: -118.116313, n: "Lakewood, CA, USA" }; 
g["lancaster"] = { lt: 34.693937, lg: -118.135749, n: "Lancaster, CA, USA" }; 
g["lawndale"] = { lt: 33.888118, lg: -118.351906, n: "Lawndale, CA, USA" }; 
g["lomita"] = { lt: 33.794455, lg: -118.317194, n: "Lomita, CA, USA" }; 
g["long beach"] = { lt: 33.810458, lg: -118.148902, n: "Long Beach, CA, USA" }; 
g["los angeles"] = { lt: 34.061697, lg: -118.309101, n: "Los Angeles, CA, USA" }; 
g["lynwood"] = { lt: 33.922791, lg: -118.19718, n: "Lynwood, CA, USA" }; 
g["malibu"] = { lt: 34.021311, lg: -118.802271, n: "Malibu, CA, USA" }; 
g["manhattan beach"] = { lt: 33.889656, lg: -118.395996, n: "Manhattan Beach, CA, USA" }; 
g["maywood"] = { lt: 33.988196, lg: -118.186328, n: "Maywood, CA, USA" }; 
g["monrovia"] = { lt: 34.151094, lg: -117.999473, n: "Monrovia, CA, USA" }; 
g["montebello"] = { lt: 34.013441, lg: -118.108034, n: "Montebello, CA, USA" }; 
g["monterey park"] = { lt: 34.052556, lg: -118.132521, n: "Monterey Park, CA, USA" }; 
g["norwalk"] = { lt: 33.909544, lg: -118.082153, n: "Norwalk, CA, USA" }; 
g["palmdale"] = { lt: 34.601399, lg: -118.107849, n: "Palmdale, CA, USA" }; 
g["palos verdes estates"] = { lt: 33.783806, lg: -118.40513, n: "Palos Verdes Estates, CA, USA" }; 
g["paramount"] = { lt: 33.896446, lg: -118.164784, n: "Paramount, CA, USA" }; 
g["pasadena"] = { lt: 34.152352, lg: -118.127348, n: "Pasadena, CA, USA" }; 
g["pico rivera"] = { lt: 33.99192, lg: -118.090113, n: "Pico Rivera, CA, USA" }; 
g["pomona"] = { lt: 34.062164, lg: -117.756553, n: "Pomona, CA, USA" }; 
g["rancho palos verdes"] = { lt: 33.739249, lg: -118.358816, n: "Rancho Palos Verdes, CA, USA" }; 
g["redondo beach"] = { lt: 33.858276, lg: -118.378383, n: "Redondo Beach, CA, USA" }; 
g["rolling hills"] = { lt: 33.76043, lg: -118.346669, n: "Rolling Hills, CA, USA" }; 
g["rolling hills estates"] = { lt: 33.783872, lg: -118.354311, n: "Rolling Hills Estates, CA, USA" }; 
g["rosemead"] = { lt: 34.07104, lg: -118.078786, n: "Rosemead, CA, USA" }; 
g["san dimas"] = { lt: 34.103171, lg: -117.806918, n: "San Dimas, CA, USA" }; 
g["san fernando"] = { lt: 34.289777, lg: -118.435817, n: "San Fernando, CA, USA" }; 
g["san gabriel"] = { lt: 34.093428, lg: -118.097634, n: "San Gabriel, CA, USA" }; 
g["san marino"] = { lt: 34.121725, lg: -118.112051, n: "San Marino, CA, USA" }; 
g["santa clarita"] = { lt: 34.420147, lg: -118.503039, n: "Santa Clarita, CA, USA" }; 
g["santa fe springs"] = { lt: 33.931636, lg: -118.058016, n: "Santa Fe Springs, CA, USA" }; 
g["santa monica"] = { lt: 34.023295, lg: -118.480332, n: "Santa Monica, CA, USA" }; 
g["sierra madre"] = { lt: 34.168148, lg: -118.048195, n: "Sierra Madre, CA, USA" }; 
g["signal hill"] = { lt: 33.804405, lg: -118.167607, n: "Signal Hill, CA, USA" }; 
g["south el monte"] = { lt: 34.049678, lg: -118.047851, n: "South El Monte, CA, USA" }; 
g["south gate"] = { lt: 33.947057, lg: -118.190642, n: "South Gate, CA, USA" }; 
g["south pasadena"] = { lt: 34.111987, lg: -118.155293, n: "South Pasadena, CA, USA" }; 
g["temple city"] = { lt: 34.101186, lg: -118.05538, n: "Temple City, CA, USA" }; 
g["torrance"] = { lt: 33.834347, lg: -118.339608, n: "Torrance, CA, USA" }; 
g["vernon"] = { lt: 34.000368, lg: -118.204481, n: "Vernon, CA, USA" }; 
g["walnut"] = { lt: 34.034381, lg: -117.856007, n: "Walnut, CA, USA" }; 
g["west covina"] = { lt: 34.060965, lg: -117.907894, n: "West Covina, CA, USA" }; 
g["west hollywood"] = { lt: 34.090287, lg: -118.367037, n: "West Hollywood, CA, USA" }; 
g["westlake village"] = { lt: 34.146107, lg: -118.805897, n: "Westlake Village, CA, USA" }; 
g["whittier"] = { lt: 33.96819, lg: -118.018568, n: "Whittier, CA, USA" }; 

// orange county
g["aliso viejo"] = { lt: 33.581255, lg: -117.72707, n: "Aliso Viejo, CA, USA" }; 
g["anaheim"] = { lt: 33.847088, lg: -117.878453, n: "Anaheim, CA, USA" }; 
g["brea"] = { lt: 33.924501, lg: -117.868811, n: "Brea, CA, USA" }; 
g["buena park"] = { lt: 33.857153, lg: -118.004381, n: "Buena Park, CA, USA" }; 
g["costa mesa"] = { lt: 33.668889, lg: -117.905225, n: "Costa Mesa, CA, USA" }; 
g["cypress"] = { lt: 33.817042, lg: -118.036809, n: "Cypress, CA, USA" }; 
g["dana point"] = { lt: 33.468997, lg: -117.683977, n: "Dana Point, CA, USA" }; 
g["fountain valley"] = { lt: 33.708584, lg: -117.945307, n: "Fountain Valley, CA, USA" }; 
g["fullerton"] = { lt: 33.883143, lg: -117.924664, n: "Fullerton, CA, USA" }; 
g["garden grove"] = { lt: 33.78135, lg: -117.967504, n: "Garden Grove, CA, USA" }; 
g["huntington beach"] = { lt: 33.701262, lg: -117.98937, n: "Huntington Beach, CA, USA" }; 
g["irvine"] = { lt: 33.675588, lg: -117.765744, n: "Irvine, CA, USA" }; 
g["la habra"] = { lt: 33.928667, lg: -117.94609, n: "La Habra, CA, USA" }; 
g["la palma"] = { lt: 33.85144, lg: -118.039422, n: "La Palma, CA, USA" }; 
g["laguna beach"] = { lt: 33.543069, lg: -117.766323, n: "Laguna Beach, CA, USA" }; 
g["laguna hills"] = { lt: 33.597582, lg: -117.693688, n: "Laguna Hills, CA, USA" }; 
g["laguna niguel"] = { lt: 33.532254, lg: -117.703084, n: "Laguna Niguel, CA, USA" }; 
g["laguna woods"] = { lt: 33.610124, lg: -117.72517, n: "Laguna Woods, CA, USA" }; 
g["lake forest"] = { lt: 33.657604, lg: -117.671524, n: "Lake Forest, CA, USA" }; 
g["los alamitos"] = { lt: 33.799415, lg: -118.054514, n: "Los Alamitos, CA, USA" }; 
g["mission viejo"] = { lt: 33.607752, lg: -117.650832, n: "Mission Viejo, CA, USA" }; 
g["newport beach"] = { lt: 33.611891, lg: -117.865374, n: "Newport Beach, CA, USA" }; 
g["orange"] = { lt: 33.808111, lg: -117.822241, n: "Orange, CA, USA" }; 
g["placentia"] = { lt: 33.879808, lg: -117.843659, n: "Placentia, CA, USA" }; 
g["rancho santa margarita"] = { lt: 33.630455, lg: -117.597391, n: "Rancho Santa Margarita, CA, USA" }; 
g["san clemente"] = { lt: 33.453152, lg: -117.606544, n: "San Clemente, CA, USA" }; 
g["san juan capistrano"] = { lt: 33.501092, lg: -117.652906, n: "San Juan Capistrano, CA, USA" }; 
g["santa ana"] = { lt: 33.739401, lg: -117.87644, n: "Santa Ana, CA, USA" }; 
g["seal beach"] = { lt: 33.75502, lg: -118.071963, n: "Seal Beach, CA, USA" }; 
g["stanton"] = { lt: 33.796665, lg: -117.992468, n: "Stanton, CA, USA" }; 
g["tustin"] = { lt: 33.728107, lg: -117.815935, n: "Tustin, CA, USA" }; 
g["villa park"] = { lt: 33.817958, lg: -117.809135, n: "Villa Park, CA, USA" }; 
g["westminster"] = { lt: 33.751967, lg: -117.989372, n: "Westminster, CA, USA" }; 
g["yorba linda"] = { lt: 33.890909, lg: -117.768418, n: "Yorba Linda, CA, USA" }; 

module.exports.gps = g;

// console.log("module.exports.gps:", module.exports.gps);


// console.log("out:", module.exports.gps["stanton"]);